import { useEffect, useState } from 'react';
import { Input } from '../';
import imagen1 from '../../assets/feedback/imagen-1.png';
import imagen2 from '../../assets/feedback/imagen-2.png';
import imagen3 from '../../assets/feedback/imagen-3.png';
import imagen4 from '../../assets/feedback/imagen-4.png';
import imagen5 from '../../assets/feedback/imagen-5.png';
import './styles.scss';

import { Cancel } from '../Icons/Cancel';
import { Edit } from '../Icons/Edit';
import { Save } from '../Icons/Save';

type FeedbackProps = {
	aprobado?: unknown;
	liquidacionforecast?: unknown;
	id?: unknown;
	value?: unknown;
	handleModal?: (...args: unknown[]) => void;
	name?: string;
	nombretalento?: string;
	selectedValue?: unknown;
	disabled?: boolean;
	onSelectedImageChange?: (...args: unknown[]) => void;
	onIsClickedEdit?: (...args: unknown[]) => void;
	comentarioFeedbackBd?: string;
	hookForm?: any;
};

type Mode = 'idle' | 'editing' | 'saved';

const KEYCODE_ACCENT = 226;

const IMAGENES = [
	{
		id: 1,
		src: imagen1,
		alt: 'Imagen 1',
		tooltip: 'Muy malo',
	},
	{
		id: 2,
		src: imagen2,
		alt: 'Imagen 2',
		tooltip: 'Malo',
	},
	{
		id: 3,
		src: imagen3,
		alt: 'Imagen 3',
		tooltip: 'Regular',
	},
	{
		id: 4,
		src: imagen4,
		alt: 'Imagen 4',
		tooltip: 'Bueno',
	},
	{
		id: 5,
		src: imagen5,
		alt: 'Imagen 5',
		tooltip: 'Muy Bueno',
	},
];

export const Feedback = ({
	aprobado,
	liquidacionforecast,
	id,
	value,
	handleModal,
	name,
	nombretalento,
	selectedValue,
	disabled = false,
	onSelectedImageChange,
	onIsClickedEdit,
	comentarioFeedbackBd = '',
	hookForm = { formState: { errors: {} } } as any,
}: FeedbackProps) => {
	const {
		register,
		watch,
		formState: { errors },
	} = hookForm;

	const [selectedImageId, setSelectedImageId] = useState<number>(0);
	const [_showTooltip, _setShowTooltip] = useState(false);
	const [mode, setMode] = useState<Mode>('idle');
	const [originalSelectedImageId, setOriginalSelectedImageId] =
		useState(selectedValue);

	useEffect(() => {
		setOriginalSelectedImageId(selectedValue);
	}, [selectedValue]);

	const isClickedEdit = mode === 'editing';
	const isClickedGuardar = mode === 'saved';

	const isImageSelected = (imagenId: number) => {
		if (aprobado === false) {
			return selectedImageId === imagenId;
		}
		if (mode === 'idle') {
			return originalSelectedImageId === imagenId;
		}
		if (mode === 'editing') {
			return selectedImageId === imagenId;
		}
		if (mode === 'saved') {
			return selectedImageId === imagenId;
		}
		return false;
	};

	const handleImageClick = (imagenId: number) => {
		if (selectedImageId === imagenId) {
			onSelectedImageChange?.(0);
			setSelectedImageId(0);
		} else {
			onSelectedImageChange?.(imagenId);
			setSelectedImageId(imagenId);
		}
	};

	const handleClickEditar = () => {
		setMode('editing');
		onIsClickedEdit?.(true);
		setSelectedImageId(originalSelectedImageId as number);
	};

	const handleClickCancel = () => {
		setMode('idle');
		onSelectedImageChange?.(null);
		onIsClickedEdit?.(false);
		setSelectedImageId(0);
		hookForm.setValue(name, comentarioFeedbackBd, { shouldValidate: true });
	};

	const handleClickGuardar = async () => {
		const isValid = await hookForm.trigger(name);
		if (isValid) {
			setMode('saved');
			onIsClickedEdit?.(false);
			onSelectedImageChange?.(selectedImageId);
			handleModal?.();
		}
	};

	const handleOnKeyDown = (event: React.KeyboardEvent) => {
		if (event.keyCode === KEYCODE_ACCENT) {
			event.preventDefault();
		}
	};

	const getTextoAyuda = () => {
		if (selectedImageId >= 3) {
			console.log(selectedImageId)
			return '¿Qué debe mejorar o mantener el talento para lograr el nivel 5 en una próxima evaluación?';
		}
		return 'Déjanos tu feedback sobre el talento calificado';
	};

	return (
		<div className="textFeedback">
			<div
				className={`contenedor-hijo-grande ${aprobado && !isClickedEdit ? 'disabled' : 'no-disabled'}`}
			>
				<div className="container-label-icon">
					<div className="textFeedback__label">
						Compártenos tu experiencia del mes con el talento {nombretalento}
					</div>
				</div>
				<div>
					<div className="image-row">
						{IMAGENES.map((imagen) => (
							<div key={imagen.id} className="container-image-label">
								<img
									className={`small-image ${isImageSelected(imagen.id) ? 'selected' : 'not-selected'}`}
									src={imagen.src}
									alt={imagen.alt}
									title={imagen.tooltip}
									onClick={() => handleImageClick(imagen.id)}
									onMouseOver={(e) => {
										e.currentTarget.style.transform = 'scale(1.2)';
									}}
									onMouseOut={(e) => {
										e.currentTarget.style.transform = 'scale(1)';
									}}
									{...register?.(name)}
								/>
								<span
									className={
										isImageSelected(imagen.id)
											? 'selected_label'
											: 'not-selected_label'
									}
									id={String(imagen.id)}
								>
									{imagen.tooltip}
								</span>
							</div>
						))}
					</div>
					{(selectedImageId > 0 || aprobado) && (
						<>
							{!aprobado && (
								<div className="textFeedback__label">
									<strong className="container-label-icon">
										{getTextoAyuda()}
									</strong>
								</div>
							)}
							<div className="textAreaComponent">
								<Input
									name={name}
									hookForm={hookForm}
									onKeyDown={!aprobado ? handleOnKeyDown : undefined}
									placeholder={aprobado ? "Feedback del talento" : undefined}
									disabled={aprobado ? !isClickedEdit : false}
								/>
							</div>
						</>
					)}
				</div>
			</div>
			<div className="contenedor-hijo-pequeno">
				<div style={{ display: aprobado === false ? 'none' : undefined }}>
					<span title="Editar">
						<Edit
							className="icon"
							title={'Editar Feedback'}
							style={{
								cursor: 'pointer',
								marginLeft: '10px',
								display: isClickedEdit ? 'none' : 'block',
							}}
							onClick={handleClickEditar}
						/>
					</span>
					<span title="Cancelar">
						<Cancel
							className="icon"
							title={'Cancelar'}
							style={{
								cursor: 'pointer',
								marginLeft: '10px',
								display: !isClickedEdit ? 'none' : 'block',
							}}
							onClick={handleClickCancel}
						/>
					</span>
					<span title="Guardar">
						<Save
							className="icon"
							title={'Guardar'}
							style={{
								cursor: 'pointer',
								marginLeft: '10px',
								display: !isClickedEdit ? 'none' : 'block',
							}}
							onClick={handleClickGuardar}
						/>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Feedback;